import {createGlobalStyle} from 'styled-components';

const mainFont = 'Open Sans, sans-serif';
const mainFontSize = '14px';

export const GlobalStyle = createGlobalStyle`
  * {
      box-sizing: border-box;
    }
   
    html, body {
      width: 100%;
      height: 100%;
      margin: 0;
      padding: 0;
      font-family: ${mainFont};
      font-size: ${mainFontSize};
      color: #909090;
      background: #F5F4FA;
    }
    
    h1,h2,h3,h4,h5,h6,p,span,select,input {
      margin: 0;
      padding: 0;
      border: none;
      outline: none;
    }
    
    ul, ol {
      margin: 0;
      padding: 0;
      list-style: none;
    }
    
    input, select {
      color: #909090;
    }
    
    button {
      padding: 0;
      font: inherit;
      background-color: transparent;
      cursor: pointer;
    }
    
    a {
      color: inherit;
      text-decoration: none;
      transition: all .3s ease;
    }
    a:hover {
      color: #277661;
    }
    a:hover, a:focus, a:active {
      text-decoration: none;
    }
    
    a.default-link {
      color: #277661;
      transition: all .1s ease;
      &:hover {
        text-decoration: underline;
      }
    }
    p {
    text-align: justify;
    }
    
    //Progressbar custom style
    #nprogress .bar {
      height: 5px;
      background: #2ad0a4;
      z-index: 1999;
    }
    #nprogress .peg {
      box-shadow: 0 0 10px #2ad0a4, 0 0 5px #2ad0a4;
    }
    #nprogress .spinner-icon {
      border-top-color: #2ad0a4;
      border-left-color: #2ad0a4;
    }

  .dropdown-filter-with-date {
    .MuiMenuItem-root {
      overflow: inherit;
    }
    .MuiPopover-paper {
      overflow-x: hidden;
      overflow-y: auto;
    }
    ul {
      min-width: 295px;
    }
  }

  .example-csv {
    b {
      padding-bottom: 5px;
      display: inline-flex;
    }
    a {
      padding: 5px 0;
      display: inline-flex;
      text-decoration: underline;
    }
  }

  #menu-lang ul {
    .lang-select__pref {
      display: none;
    }
  }
  
  .exchanger-select {
    &__option {
      width: 100%;
      display: flex;
      justify-content: space-between;
      .balance {
        max-width: 45%;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
  }
`;